<div>
    <ion-row class="parent-body" [ngClass]="floatingItemType">
      <ion-col [size]="pairedItemInputDiv" class="paired-column" [ngClass]="pairedType">
        <div class="pairedDiv">
          <label class="helpText2" data-cy="myPairedLender-dscr">
            {{preferred_headeer_message}}
          </label>
          <div class="input-button">

            <algolia-search-with-invite
              *ngIf="instanceName"
              [instanceName]="instanceName"
              [hideResultsIfAlreadyPaired]="myRole === 'agentAdmin'"
              [hideInviteButton]="hideInviteButton"
              [roleOfUserToInvite]="type"
              [noResultsMessage]="noResultsMessage"
            />

          </div>
        </div>
      </ion-col>
      <ion-col [size]="pairedItemContainerDiv" class="default-lender">
        <div class="loanOfficerDiv" *ngIf="loanOfficer && (type ==='lender' || type === 'agentAdmin')">
          <div class="loanOfficerWrapper link" (click)="showEnhancedModal()"
            data-cy="listDet-pairedLender-learnMoreBtn">
            <div class="loanOfficerImgDiv">
              <app-profile-image-item class="loanOfficerImg" [profile]="loanOfficer"></app-profile-image-item>
            </div>
            <div class="loanOfficerSection">
              <div class="grey-message-area"> Default lender for {{state}} </div>
              <ion-icon *ngIf="!isDesktop" class="slotButtonIcon noTooltip" slot="icon-only" tappable
                ios="information-circle-sharp" md="information-circle-sharp"></ion-icon>
              <div class="pad-5 subTitle bold floating-user-name" data-cy="pairedLender-name"> {{name}} </div>
              <div class="pad-5 subTitle floating-company" data-cy="listDet-pairedLender-company"> {{company}}</div>
              <div class="pad-5 subTitle bold" *ngIf="isDesktop"> Learn More </div>
            </div>
          </div>
        </div>
        <div class="loanOfficerDiv" *ngIf="type === 'agent' && isSubscribed">
          <div class="paired-agent-section">
            <div class="link-label">
              <ion-label> Share your pairing link </ion-label>
            </div>
            <div class="container">
              <ion-row>
                <ion-col [size]="10" class="pairing-link">
                  <ion-label> {{pairingLink}} </ion-label>
                </ion-col>
                <ion-col [size]="2" class="copy-col rightAlign">
                  <ion-button size="small" fill="clear" class="cpy-lnk-marg inline-block" ion-button
                    (click)="copySlug($event)" data-cy="my-paired-agent-hdr-copyBtn">
                    <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="copy-outline"></ion-icon>
                  </ion-button>
                </ion-col>
              </ion-row>
            </div>
            <div class="container" *ngIf="myRole !== 'agentAdmin'">
              <ion-col [size]="8" class="inviteLabel">
                <div>
                  Want us to invite your agents?
                </div>
              </ion-col>
              <ion-col [size]="4" class="inviteLabel rightAlign">
                <ion-label class="link bold" color="primary" (click)="inviteHereAction()">
                  Invite Here
                </ion-label>
              </ion-col>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <div class="collapsy">

      <div class="searchWrapper">
      </div>

    </div>
</div>